<div class="card card-container" (click)="onCardClick()">
    <div class="card-body">

        <div class="year-text">{{data?.ReviewYear}}</div>

        <i class="fa fa-plus-circle dw-red add-icon" [hidden]="!showAdd" title="Setup New Custom Questions for this {{data?.EmployeeReviewQuestionSetupLevelId == 1 ? 'level' : levels[data?.EmployeeReviewQuestionSetupLevelId]?.Display }}"></i>
        <div class="more-icons">
            <!-- <span class="fa-stack fa-2x more-icon" [hidden]="!showHideBidding" title="Bidding questions are hidden">
                <i class="fa fa-sack-dollar fa-stack-1x dw-blue"></i>
                <i class="fa fa-ban fa-stack-2x" style="color:Tomato"></i>
            </span>
            <span class="fa-stack fa-2x more-icon" [hidden]="!showHideRevenue" title="Revenue questions are hidden">
                <i class="fa fa-money-check-edit fa-stack-1x dw-blue"></i>
                <i class="fa fa-ban fa-stack-2x" style="color:Tomato"></i>
            </span> -->
            <i class="fa fa-sack-dollar dw-orange more-icon" [hidden]="!showHideBidding" title="Bidding questions are hidden"></i>
            <i class="fa fa-money-check-edit dw-orange more-icon" [hidden]="!showHideRevenue" title="Revenue questions are hidden"></i>
        </div>

        <i [hidden]="!levels[data?.EmployeeReviewQuestionSetupLevelId]?.IconClass" [ngClass]="levels[data?.EmployeeReviewQuestionSetupLevelId]?.IconClass" class="card-icon"></i>

        <div class="card-main-text">
            {{ levels[data?.EmployeeReviewQuestionSetupLevelId]?.Display}}
        </div>

        <div *ngIf="data?.EmployeeReviewQuestionSetupLevelId == 2" class="card-detail-text">

            {{ data?.WachterDepartmentIdDisplay}}
            
        </div>

        <div *ngIf="data?.EmployeeReviewQuestionSetupLevelId == 3" class="card-detail-text">

            {{ data?.WachterTeamIdDisplay}} 
            
        </div>
    </div>
</div>
